import React, { useContext, useEffect, useState } from "react";
import {
    Grid,
    Avatar,
    Typography,
    makeStyles,
    Link,
    Card,
    CardContent,
    CardMedia,
} from "@material-ui/core";
import useStyles from "../../../../../../css/styles_PE";
import { ApptContext, FacilitySchedule, Slots,EMRConfig } from "../../../../../../store"; //FB 8215
import { formatphone } from "../../../../../../api/PE_API";
import SlotsContainer from "../Components/SlotsContainer";

// Update log
// FB  6192   02/06/2023  DK  To display the Weekly slots for the Facility
// FB  8215   02/01/2024  GA  Portal - Provider images are wrong


interface ILocationScheduleRowProps {
    FacilitySchedules: FacilitySchedule[];
    Limited: number;
    Index: number;
    FacilityId: number;
    FacilityName: string;
    isLoading: any;
}

const Styles = makeStyles((theme) => ({
    timeSlotItem: {
        borderRadius: "16px",
        border: "0",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#EDEEEE",
        padding: "10px",
        cursor: "pointer",
        fontSize: "smaller",
    },
}));

export default function FacilitySlots(props: ILocationScheduleRowProps) {
    const classes = useStyles();
    const styles = useStyles();
    let Phone = props.FacilitySchedules[props.Index].SchedulinPhone;
    if (Phone !== null) {
        Phone = Phone.replace(/[^0-9]/g, "");
    } else {
        Phone = "";
    }

    const { state, dispatch } = useContext(ApptContext);
    const [disableEvents, setDiableEvents] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [websiteID, setWebsiteID] = useState(0); //FB 8215


    useEffect(() => {
    //FB 8215 Begin
    let data = sessionStorage.getItem("EMRConfig");
    if(data!=null){
        let emrConfig = JSON.parse(data) as EMRConfig;
        setWebsiteID(emrConfig.WebsiteID);
        }
    //FB 8215 End
    props.isLoading(isLoading);
    }, [isLoading])

    return props.FacilitySchedules !== undefined ? (
        <div>
            {window.innerWidth <= 768 ? (
                <div>
                    <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignContent="center"
                        justify="center"
                    >
                        <Grid item xs={12}>
                            <Card
                                className={styles.slotslocation_Card}
                                style={{ boxShadow: "none" }}
                            >
                                <CardMedia>
                                    <Avatar
                                        style={{ marginTop: 5 }}
                                        className={styles.slotslocation_Avatar}
                                        src={
                                            "/Images/Providers/"+websiteID+"/" +
                                            props.FacilitySchedules[props.Index]
                                                .Employee_N +
                                            ".jpg"
                                        } // FB 8215 -Added websiteID to the source path
                                    />
                                </CardMedia>
                                <CardContent>
                                    <Typography variant="h6">
                                        <b>
                                            {
                                                props.FacilitySchedules[props.Index]
                                                    .Employee_First_Name
                                            }{" "}
                                            {
                                                props.FacilitySchedules[props.Index]
                                                    .Employee_Last_Name
                                            }
                                        </b>
                                    </Typography>
                                    <Typography style={{ fontSize: "smaller" }}>
                                        {
                                            props.FacilitySchedules[props.Index]
                                                .Employee_Job_Title
                                        }
                                    </Typography>
                                    <Typography style={{ fontSize: "smaller" }}>
                                        {
                                            props.FacilitySchedules[props.Index]
                                                .Employee_Bio
                                        }
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={3}
                        direction="row"
                        alignContent="center"
                        justify="center"
                        style={{
                            display: "flex",
                            pointerEvents: disableEvents ? "none" : "auto",
                        }}
                    >
                        {props.FacilitySchedules[props.Index].NextAvailability != null &&
                            props.FacilitySchedules[props.Index].AvailableSlotsCount <= 0 ? (
                            <Grid
                                item
                                xs={10}
                                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
                            >
                                <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                                    The next available online appointment for this provider is {props.FacilitySchedules[props.Index].NextAvailability}
                                    . If you need an appointment sooner, Please call {formatphone(props.FacilitySchedules[props.Index].SchedulinPhone)}.
                                </Typography>
                            </Grid>
                        ) : props.FacilitySchedules[props.Index].AvailableSlotsCount <= 0 ? (
                            <Grid
                                item
                                xs={10}
                                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
                            >
                                <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                                    The next available online appointment for this provider is {props.FacilitySchedules[props.Index].NextAvailability}
                                    . If you need an appointment sooner, Please call {formatphone(props.FacilitySchedules[props.Index].SchedulinPhone)}.
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={10} style={{ overflowX: "auto" }}>
                                {props.FacilitySchedules[props.Index].SlotsDate.map(
                                    (ele: Slots, index: number) => (
                                        <SlotsContainer
                                            limited={props.Limited}
                                            schedulesTest={ele}
                                            key={index}
                                            employeeName={
                                                props.FacilitySchedules[props.Index]
                                                    .Employee_First_Name +
                                                " " +
                                                props.FacilitySchedules[props.Index]
                                                    .Employee_Last_Name
                                            }
                                            employeeid={
                                                props.FacilitySchedules[props.Index]
                                                    .Employee_N
                                            }
                                            facilityid={props.FacilityId}
                                            facilityName={props.FacilityName}
                                            facilityPhone={
                                                Phone === ""
                                                    ? ""
                                                    : "(" +
                                                    Phone.slice(0, 3) +
                                                    ") " +
                                                    Phone.slice(3, 6) +
                                                    "-" +
                                                    Phone.slice(6, 10)
                                            }
                                            onCallback={setDiableEvents}
                                            isLoading={setIsLoading}
                                            duration={props.FacilitySchedules[props.Index].Duration}
                                        />
                                    )
                                )}
                            </Grid>
                        )}
                    </Grid>
                </div>
            ) : (
                <Grid
                    container
                    spacing={3}
                    direction="row"
                    alignContent="center"
                    justify="flex-start"
                    style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)", marginTop: 10 }}
                >
                    <Grid item xs={4} sm={4} md={4}>
                        <Card
                            className={styles.slotslocation_Card}
                            style={{ boxShadow: "none", alignItems: "center" }}
                        >
                            <CardMedia>
                                <Avatar
                                    style={{ marginTop: 5 }}
                                    className={styles.slotslocation_Avatar}
                                    src={
                                        "/Images/Providers/"+websiteID +"/"+
                                        props.FacilitySchedules[props.Index].Employee_N +
                                        ".jpg"
                                    } // FB 8215 -Added websiteID to the source path
                                />
                            </CardMedia>
                            <CardContent style={{ display: "contents" }}>
                                <Typography variant="h6">
                                    <b>
                                        {
                                            props.FacilitySchedules[props.Index]
                                                .Employee_First_Name
                                        }{" "}
                                        {
                                            props.FacilitySchedules[props.Index]
                                                .Employee_Last_Name
                                        }
                                    </b>
                                </Typography>
                                <Typography style={{ fontSize: "smaller" }}>
                                    {props.FacilitySchedules[props.Index].Employee_Job_Title}
                                </Typography>
                                <Typography style={{ fontSize: "smaller" }}>
                                    {props.FacilitySchedules[props.Index].Employee_Bio}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        sm={7}
                        md={7}
                        style={{
                            display: "flex",
                            pointerEvents: disableEvents ? "none" : "auto",
                        }}
                        direction="row"
                        alignContent="space-around"
                        justify="space-around"
                    >
                        {props.FacilitySchedules[props.Index].AvailableSlotsCount <= 0 ? (
                            <Grid item style={{ margin: "auto" }}>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignItems="center"
                                >
                                    {props.FacilitySchedules[props.Index].NextAvailability != null ?
                                        (<div className={classes.timeSlotItem}>
                                            <Typography
                                                variant="subtitle2"
                                                style={{ textAlign: "center" }}
                                            >
                                                The next available online appointment for this provider is {props.FacilitySchedules[props.Index].NextAvailability}
                                                . If you need an appointment sooner, Please call {formatphone(props.FacilitySchedules[props.Index].SchedulinPhone)}.
                                            </Typography>
                                        </div>) : (
                                            <div className={classes.timeSlotItem}>
                                                <Typography
                                                    variant="subtitle2"
                                                    style={{ textAlign: "center" }}
                                                >
                                                    There are no online appointments available for this provider. Please call {formatphone(props.FacilitySchedules[props.Index].SchedulinPhone)} to book an appointment.
                                                </Typography>
                                            </div>)}
                                </Grid>
                            </Grid>
                        ) : props.FacilitySchedules[props.Index].AvailableSlotsCount <= 0 ? (
                            <Grid item style={{ margin: "auto" }}>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <div className={classes.timeSlotItem}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ textAlign: "center" }}
                                        >
                                            {props.FacilitySchedules[props.Index].NextAvailability != null ?
                                                "The next available online appointment for this provider is " +
                                                props.FacilitySchedules[props.Index].NextAvailability + ". If you need an appointment sooner, Please call " + formatphone(props.FacilitySchedules[props.Index].SchedulinPhone) + "."
                                                :
                                                "There are no online appointments available for this provider. Please call " + formatphone(props.FacilitySchedules[props.Index].SchedulinPhone) + " to book an appointment."}
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        ) : (
                            props.FacilitySchedules[
                                props.Index
                            ].SlotsDate.map((ele: Slots, index: number) => (
                                <SlotsContainer
                                    limited={props.Limited}
                                    schedulesTest={ele}
                                    key={index}
                                    employeeName={
                                        props.FacilitySchedules[props.Index]
                                            .Employee_First_Name +
                                        " " +
                                        props.FacilitySchedules[props.Index]
                                            .Employee_Last_Name
                                    }
                                    employeeid={
                                        props.FacilitySchedules[props.Index].Employee_N
                                    }
                                    facilityid={props.FacilityId}
                                    facilityName={props.FacilityName}
                                    facilityPhone={
                                        Phone === ""
                                            ? ""
                                            : "(" +
                                            Phone.slice(0, 3) +
                                            ") " +
                                            Phone.slice(3, 6) +
                                            "-" +
                                            Phone.slice(6, 10)
                                    }
                                    onCallback={setDiableEvents}
                                    isLoading={setIsLoading}  //FB 4409 DK - Added to update the isLoading flag on slots page
                                    duration={props.FacilitySchedules[props.Index].Duration} //FB 4638 added appt duration
                                />
                            ))
                        )}
                    </Grid>
                </Grid>
            )}
        </div>
    ) : (
        <></>
    );
}